import { forwardRef } from 'react';

/**
 * Component that renders a <modal-overlay> Web Component.
 * The forward ref allows us to reference the modal when creating one.
 *
 * @returns {ModalOverlayElement}
 */
const ModalOverlay = forwardRef(({ children }, ref) => (
    <modal-overlay ref={ref}>
        <button slot="close" className="btn-slider">
            <i className="fas fa-times"></i>
        </button>

        {children}
    </modal-overlay>
));

export default ModalOverlay;
